import { createContext } from 'react';

export type BankAccountTransferCtx = {
  showBankAccountTransferErrorAlert: boolean;
  bankAccountTransferError: string;
};

const BankAccountTransferDialogueContext = createContext<BankAccountTransferCtx>({
  showBankAccountTransferErrorAlert: false,
  bankAccountTransferError: '',
});

export default BankAccountTransferDialogueContext;